import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
const defaultAnimationLength = 550;
export const animationLength = (multiplier: number = 1) =>
  `${defaultAnimationLength * multiplier}ms`;

export const dynamicAnimation = trigger('dynamicAnimation', [
  state(
    'up',
    style({ transform: 'translateY(0)', opacity: '*', filter: 'blur(0)' }),
  ),
  state(
    'right',
    style({ transform: 'translateX(0)', opacity: '*', filter: 'blur(0)' }),
  ),
  state(
    'down',
    style({ transform: 'translateY(0)', opacity: '*', filter: 'blur(0)' }),
  ),
  state(
    'left',
    style({ transform: 'translateX(0)', opacity: '*', filter: 'blur(0)' }),
  ),
  state(
    'center',
    style({ transform: 'scale(1)', opacity: '*', filter: 'blur(0)' }),
  ),
  state(
    'downLeave',
    style({ transform: 'translateY(0)', opacity: '*', filter: 'blur(0)' }),
  ),

  transition(
    '* => up',
    [
      style({
        transform: 'translateY(20px)',
        opacity: 0.6,
        filter: 'blur({{blurAmount}})',
      }),
      animate(
        `${animationLength()} cubic-bezier(0.25, 1, 0.5, 1)`,
        style({ transform: 'translateY(0)', opacity: '*', filter: 'blur(0)' }),
      ),
    ],
    { params: { blurAmount: '0px' } },
  ),

  transition(
    '* => right',
    [
      style({
        transform: 'translateX(-20px)',
        opacity: 0.6,
        filter: 'blur({{blurAmount}})',
      }),
      animate(
        `${animationLength()} cubic-bezier(0.25, 1, 0.5, 1)`,
        style({ transform: 'translateX(0)', opacity: '*', filter: 'blur(0)' }),
      ),
    ],
    { params: { blurAmount: '0px' } },
  ),

  transition(
    '* => down',
    [
      style({
        transform: 'translateY(-20px)',
        opacity: 0.6,
        filter: 'blur({{blurAmount}})',
      }),
      animate(
        `${animationLength()} cubic-bezier(0.25, 1, 0.5, 1)`,
        style({ transform: 'translateY(0)', opacity: '*', filter: 'blur(0)' }),
      ),
    ],
    { params: { blurAmount: '0px' } },
  ),

  transition(
    '* => left',
    [
      style({
        transform: 'translateX(20px)',
        opacity: 0.6,
        filter: 'blur({{blurAmount}})',
      }),
      animate(
        `${animationLength()} cubic-bezier(0.25, 1, 0.5, 1)`,
        style({ transform: 'translateX(0)', opacity: '*', filter: 'blur(0)' }),
      ),
    ],
    { params: { blurAmount: '0px' } },
  ),

  transition(
    'void => center',
    [
      style({
        transform: 'scale(1)',
        opacity: 0.6,
        filter: 'blur({{blurAmount}})',
      }),
      animate(
        `${animationLength()} cubic-bezier(0.25, 1, 0.5, 1)`,
        style({ transform: 'scale(1)', opacity: '*', filter: 'blur(0)' }),
      ),
    ],
    { params: { blurAmount: '0px' } },
  ),

  transition(
    '* => downLeave',
    [
      style({ transform: 'translateY(0)', opacity: '*', filter: 'blur(0)' }),
      animate(
        `${animationLength()} cubic-bezier(0.25, 1, 0.5, 1)`,
        style({
          transform: 'translateY(200px)',
          opacity: 0.6,
          filter: 'blur({{blurAmount}})',
        }),
      ),
    ],
    { params: { blurAmount: '0px' } },
  ),
]);
